<template>
  <div class="d-flex m-3 gap-2">

    <!-- Main Content -->
    <div class="w-75 d-flex flex-column gap-3">
      <div class="card border-0 p-3 shadow-sm w-100 mb-3">
        <h4>Toggle</h4>
        <p class="text-gray-600 mb-2">Use toggles to prompt users to choose between two mutually exclusive options. This component uses a library from Vueform.</p>
        <a href="https://github.com/vueform/toggle">Check Vueform Toggle for more details ></a>
        <p class="text-gray-600 mt-4 mb-2 font-weight-bold">Installation</p>
        <code class="bg-gray-100 p-3">npm install @vueform/toggle</code>
      
        <p class="text-gray-600 mt-5 mb-2 font-weight-bold">Installation with Vue 2</p>
        <small class="text-gray-600 mt-2 mb-2">Install @vue/composition-api via npm/yarn first:</small>
        <code class="bg-gray-100 p-3">npm i @vue/composition-api --save-dev</code>

        <small class="text-gray-600 mt-4 mb-2">Then install the plugin for Vue:</small>
        <code class="bg-gray-100 p-3">
          <p>import Vue from 'vue'</p>
          <p>import VueCompositionAPI from '@vue/composition-api'</p>
          <p>Vue.use(VueCompositionAPI)</p>
        </code>

        <h5 class="mt-5 mb-2">How to Import</h5>
        <p class="text-gray-600">To import the Toggle component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2">yarn add @bit/dtt.uic.dt-toggle</code>
      </div>

      <ToggleOverview />

      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="my-2">Props</h4>
        <b-table striped bordered :items="items" :fields="fields"></b-table>
      </div>
    </div>

   
  </div>
</template>

<script>
import ToggleOverview from '@/components/local/Toggle/ToggleOverview'

export default {
  components: { 
    ToggleOverview
  },

  data () {
    return {
      components: [
        { name: 'Buttons', link: 'buttons' },
        { name: 'Toggle', link: 'toggle' },
      ],

      fields: [
        { key: 'prop', tdClass: 'setAmountTdClass' },
        { key: 'type', tdClass: 'setAmountTdClass' },
        { key: 'default', tdClass: 'setAmountTdClass' },
        { key: 'description' }
      ],

      items: [
          { prop: 'id', type: 'String', default: 'null', description: 'The id attribute of the toggle. Make sure to customize when using more toggles on a single page.' },
          { prop: 'name', type: 'String', default: 'null', description: 'The name attribute of the toggle.' },
          { prop: 'true-value', type: 'String, Boolean', default: 'true', description: 'The value when the toggle is on.' },
          { prop: 'false-value', type: 'String, Boolean', default: 'false', description: 'The value when the toggle is off.' },
          { prop: 'left-label', type: 'String', default: '', description: 'Left side label of the toggle.' },
          { prop: 'right-label', type: 'String', default: '', description: 'Right side label of the toggle.' },
          { prop: 'size', type: 'String', default: 'md', description: "Set the size of the component's appearance. 'sm' or 'lg'" },
          { prop: 'disabled', type: 'Boolean', default: 'false', description: 'Whether the toggle should be disabled.' },
          { prop: 'required', type: 'Boolean', default: 'false', description: 'Whether the HTML5 required attribute should be used for toggle (using an invisible fake input).' },
      ],  
    }
  },

  methods: {
    setAmountTdClass() {
        return 'code-text'
    }
  }
}
</script>

<style>
  .code-text {
    font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono" ,"Courier New", monospace;
    color: red!important;
  }
</style>